import React from 'react';

import classNames from 'classnames';

import { ReactComponent as BanIcon } from 'assets/icons/ban.svg';
import { ReactComponent as ColorWheelIcon } from 'assets/icons/colorWheel.svg';

import { colorPickerDefaultColors } from '../constants';
import styles from './ColorPicker.module.scss';

const ColorPicker: React.FC<{
  theme: 'white' | 'dark';
  value: string;
  onChange: (color: string, fromNativeColorPicker: boolean) => void;
  allowTransparent?: boolean;
  onNativeColopirckerBlur?: () => void;
}> = ({ value, onChange, theme, allowTransparent = true, onNativeColopirckerBlur }) => {
  return (
    <div
      className={classNames(styles.container, 'eventShield', {
        [styles.whiteTheme]: theme === 'white',
        [styles.darkTheme]: theme === 'dark',
      })}
    >
      {colorPickerDefaultColors.map((color, index) => (
        <div
          key={color}
          onClick={() => onChange(color, false)}
          className={classNames(styles.item, `t-whiteboard-colorPicker-${index}`, {
            [styles.itemSelected]: value.toLocaleLowerCase() === color.toLocaleLowerCase(),
          })}
        >
          <div className={styles.itemInner} style={{ backgroundColor: color }}></div>
        </div>
      ))}
      <div className={styles.item}>
        <div className={styles.itemInner} style={{ position: 'relative', overflow: 'hidden' }}>
          <ColorWheelIcon className={'absolute'} style={{ width: 20, height: 20 }} tabIndex={1} />
          <input
            className={'absolute'}
            style={{ opacity: 0.01, cursor: 'pointer' }}
            type="color"
            tabIndex={1}
            value={value}
            onChange={e => {
              onChange(e.target.value, true);
            }}
            onBlur={onNativeColopirckerBlur}
          />
        </div>
      </div>
      {allowTransparent && (
        <div
          className={classNames(styles.item, styles.transparentIconContainer)}
          onClick={() => onChange('transparent', false)}
        >
          <div className={styles.itemInner} style={{ position: 'relative', overflow: 'hidden' }}>
            <BanIcon />
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(ColorPicker);
